export const PAGINATION_FIELDS = ['currentPage', 'perPage', 'totalCount', 'totalPages'] as const;
// string literal union type
// type PAGINATION_FIELD = typeof PAGINATION_FIELDS[number];
